import { useHistory } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

import { Button, Link, makeStyles } from "@fluentui/react-components";

import { translate } from "@/utils/translations";
import { EnvironmentContext } from "@/utils/environment";

import TutorialPage from "./TutorialPage";
import { Logo } from "../components/Logo";

export function LoginPage() {
  const history = useHistory();
  const [firstRun, setFirstRun] = useState(false);
  const styles = useStyles();
  const { setEnv } = useContext(EnvironmentContext);

  const handleCequenceLogin = () => {
    history.push("/cequence-login");
  };

  useEffect(() => {
    const firstRunValue = localStorage.getItem("firstRun");
	setEnv(null);
    if (firstRunValue) {
      setFirstRun(false);
    }

    if (!firstRunValue) {
      localStorage.setItem("firstRun", "true");
    }
  }, []);

  if (firstRun) {
    return (
      <TutorialPage
        onSkip={() => {
          setFirstRun(false);
        }}
      />
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <Logo size={32} withoutText />
        <h1 className={styles.title}>{translate("Assistant")}</h1>
      </div>
      <p className={styles.subtitle}>
        {translate("Your AI contract assistant")}
      </p>

      <div className={styles.buttonContainer}>
        <Button appearance="secondary" onClick={handleCequenceLogin}>
          {translate("Sign in with Cequence account")}
        </Button>
      </div>

      <div className={styles.footer}>
        <div>© Copyright {new Date().getFullYear()} Cequence s. r. o.</div>
        <div className={styles.footerLinks}>
          <Link
            href="https://cequence.io/contact"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
            }}
          >
            {translate("Support")}
          </Link>
          <Link
            href="https://cequence.io/terms"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
            }}
          >
            {translate("Terms")}
          </Link>
          <Link
            href="https://cequence.io/privacy"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
            }}
          >
            {translate("Privacy")}
          </Link>
        </div>
        <div className={styles.version}>v1.03</div>
      </div>
    </div>
  );
}

const useStyles = makeStyles({
  button: {
    fontSize: "16px",
    height: "48px",
    width: "100%",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxWidth: "320px",
    width: "100%",
  },
  container: {
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "20px",
  },
  footer: {
    bottom: "20px",
    color: "#605e5c",
    fontSize: "12px",
    left: "50%",
    position: "fixed",
    textAlign: "center",
    transform: "translateX(-50%)",
    width: "100%",
  },
  footerLinks: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "8px",
  },
  logo: {
    alignItems: "center",
    backgroundColor: "#0078d4",
    borderRadius: "50%",
    color: "white",
    display: "flex",
    fontSize: "24px",
    fontWeight: "bold",
    height: "48px",
    justifyContent: "center",
    marginRight: "12px",
    width: "48px",
  },
  logoContainer: {
    alignItems: "center",
    display: "flex",
    gap: "8px",
    marginBottom: "8px",
  },
  microsoftButton: {
    backgroundColor: "white",
    border: "1px solid #d2d0ce",
    color: "#323130",
  },
  subtitle: {
    color: "#605e5c",
    fontSize: "14px",
    fontWeight: "400",
    marginBottom: "60px",
  },
  title: {
    color: "#323130",
    fontSize: "32px",
    fontWeight: "700",
    margin: "0",
  },
  version: {
    color: "#a19f9d",
    marginTop: "8px",
  },
});
